// extracted by mini-css-extract-plugin
export default {"Overlay":"_jfHfLvm","FloatingOverlay":"CgMOASxA","OverlayContainer":"UZPB3Z3_","OverlayContainerContent":"vWIHtTry","OverlaySurface":"px6WwADm"};